import { useMemo } from "react";
import { Gate, RelationType, WhereItem, WhereItems } from "../../globalTypes";
import { TableColumnInputType } from "../../requests/table/types";
import { getDefaultRelationTypeForInputType } from "../../components/molecules/WhereItemEditor/utils";
import {
  ColumnInfo,
  TableInfoGetters,
} from "../../components/molecules/WhereItemEditor/types";

const isTypeSameAsDefaultType = (
  type: RelationType,
  presentationInputType: TableColumnInputType,
  unformattedInputType: TableColumnInputType
): boolean => {
  const defaultType = getDefaultRelationTypeForInputType(unformattedInputType);
  return (
    type === defaultType ||
    presentationInputType === "dateFrom" ||
    presentationInputType === "dateTo"
  );
};

// Určuje, jestli jde item vykreslit v SimplifiedWhereItemEditor
function determineIfWhereItemSimple(
  item: WhereItem,
  colInfo: ColumnInfo | undefined
): boolean {
  const {
    relation: { type, operator },
    isList,
    gate,
  } = item;

  if (!colInfo) {
    return true;
  }

  // Children hlídat nepotřebuju, stačí že neni type WhereItemArray
  if (gate !== Gate.And) {
    return false;
  }

  // unformattedInputType pro select je "text"
  if (
    !isTypeSameAsDefaultType(
      type,
      colInfo.presentationInputType,
      colInfo.unformattedInputType
    ) &&
    !colInfo.isSelect
  ) {
    isTypeSameAsDefaultType(
      type,
      colInfo.presentationInputType,
      colInfo.unformattedInputType
    );
    return false;
  }

  if (operator !== "eq") {
    return false;
  }

  if (isList) {
    return false;
  }

  return true;
}

export const useIsSimpleViewPermissible = (
  whereItems: WhereItems,
  tableInfoGetters: TableInfoGetters
): boolean => {
  const getIsPermissible = () =>
    whereItems.every((whereItem) => {
      const { source } = whereItem;

      const colInfo = tableInfoGetters.sourceGetters.getColumnInfo(source);

      return determineIfWhereItemSimple(whereItem, colInfo);
    });

  // Here a potential memoization issue can arise, because `getIsPermissible` is dependent
  // on the result of getColumnInfo, but this result is not present in deps array
  return useMemo(getIsPermissible, [whereItems, tableInfoGetters]);
};
